import React from "react";
import StarRating from "./Stars";
import * as S from "./Styles";

export interface TestimonialCardProps {
  rating: number;
  customerName: string;
  testimonial: string;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ rating, customerName, testimonial }) => {
  return (
    <S.Container>
      <S.RatingContainer>
        <StarRating rating={rating} />
      </S.RatingContainer>
      <S.CustomerName>{customerName}</S.CustomerName>
      <S.Testimonial>{testimonial}</S.Testimonial>
    </S.Container>
  );
};
